import React from "react";
import styles from "./index.module.scss";

export default function ScoreOverwrite({ overwriteReason, ...props }) {
  return (
    <div className={styles.scoreOverwrite}>
      <div className={styles.scoreOverwriteWrapper}>
        <div className={styles.header}>
          <div className={styles.label}>Overwrite with passing score</div>
        </div>
        <div className={styles.textInput}>
          <div className={styles.content}>
            <p>{overwriteReason}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
